import { getVehicleData, getVehicleDataById, type VehicleListParams } from '@dc-trans/data-layer';
import { useQuery } from '@tanstack/react-query';

export const vehicleKeys = {
  all: ['vehicle'] as const,
  list: (params?: VehicleListParams) => [...vehicleKeys.all, 'list', params] as const,
  detail: (id: string) => [...vehicleKeys.all, 'detail', id] as const,
};

export const useVehicleList = (params?: VehicleListParams) => {
  return useQuery({
    queryKey: vehicleKeys.list(params),
    queryFn: () => getVehicleData(params),
  });
};

export const useVehicleDetail = (id: string) => {
  return useQuery({
    queryKey: vehicleKeys.detail(id),
    queryFn: () => getVehicleDataById(id),
    enabled: !!id,
  });
};
